import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { EMPLOYEE_PAY_LIST, UPDATE_BATCH_CSV } from 'src/constants/EndpointUrls';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { formatDate } from 'src/utils/Date';
import { ErrorsSection } from 'src/components';

import EmployeePayDownloadCsvForm from './EmployeePayDownloadCsvForm';
import DownloadColumnDetail from './DownloadColumnDetail';
import DownloadPayCsvJobStatus from './DownloadPayCsvJobStatus';
import ImportPayCsvJobStatus from './ImportPayCsvJobStatus';
import styles from './EmployeePayDownloadCsvPage.scss';

const EmployeePayDownloadCsvPage = props => {
  const { t } = useTranslation();

  props.setEmployeePays();
  props.fetchCompletedDownloadPayCsvJob();

  const { startDate, endDate } = props.values.targetPeriod;
  return (
    <div>
      <div className="l-wrap-xs l-contents-wrap">
        <BreadCrumb>
          <BreadCrumb.Item label={t('features.EmployeePays.EditEmployeePay.salary_list')} path={EMPLOYEE_PAY_LIST} />
          <BreadCrumb.Item label={t('features.EmployeePays.components.EmployeePayDownloadCsvPage.update_provision_and_deduction_items')} />
        </BreadCrumb>
      </div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">
          {t('features.EmployeePays.components.EmployeePayDownloadCsvPage.update_provision_and_deduction_items')}
        </h1>
      </div>
      <div>
        <DownloadPayCsvJobStatus />
        <ImportPayCsvJobStatus />
        <ErrorsSection errors={props.errors} />
      </div>

      <div className={classNames('l-wrap-xs', styles.description)}>
        <p>
          {t('features.EmployeePays.components.EmployeePayDownloadCsvPage.update_all_provision_and_deduction_items_used_in_payroll_in_the_following_month_by_CSV_file')}
          <br />
          {t('features.EmployeePays.components.EmployeePayDownloadCsvPage.useful_for_managing_provision_items_that_change_every_month')}
        </p>
        <ul className="u-mt10">
          <li>
            {t('features.EmployeePays.components.EmployeePayDownloadCsvPage.Cannot_change_master_data_for_employee_To_change_master_data_for_employee')}
            <a href={UPDATE_BATCH_CSV} className="u-txt-link">
              {t('features.EmployeePays.components.EmployeePayDownloadCsvPage.here')}
            </a>
          </li>
        </ul>
        <div className={styles.target}>
          {props.values.jobInfo}
          <div className={styles.period}>
            <span>
              {t('features.EmployeePays.components.EmployeePayDownloadCsvPage.subjected_period')}：{formatDate(startDate)}〜{formatDate(endDate)}
            </span>
          </div>
        </div>
      </div>
      <EmployeePayDownloadCsvForm jobInfo={props.values.jobInfo} />
      <div className={styles.detail}>
        <DownloadColumnDetail />
      </div>
    </div>
  );
};

export default EmployeePayDownloadCsvPage;
